import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';
import { StrengthSelect } from '../components/StrengthSelect';
import UnitSelect from '../components/UnitSelect';
import { otherOnChange, strengthsArray, strengthsOnChange } from '../utils';

import type { IRegimenContext } from '..';

const SingleDose = ({ formData, editIndex, packages }: IRegimenContext): React.JSX.Element => {
  const regimen = formData.document.regimen?.[editIndex] as IRegimenSingleDose;
  const allRegimen = formData.document.regimen;
  const availableStrengths = strengthsArray(packages);
  const strengths = regimen.strengths ?? [];

  return (
    <React.Fragment>
      <StrengthSelect
        formData={formData}
        availableStrengths={availableStrengths}
        strengthsOnChange={strengthsOnChange(formData.onChange, availableStrengths, editIndex, regimen, allRegimen)}
        strengths={strengths}
        editIndex={editIndex}
      />
      <FormRow title="medication.dose" headerWidth={3}>
        <InputHandler
          type="NumberField"
          name="dose"
          editing={true}
          placeholder={'medication.dose'}
          precision={4}
          width={19}
          formData={{
            onChange: otherOnChange(formData.onChange, editIndex, regimen, allRegimen),
            document: { dose: regimen.dose },
          }}
        />
      </FormRow>
      <UnitSelect
        unitValue={regimen.unit}
        onChange={otherOnChange(formData.onChange, editIndex, regimen, allRegimen)}
      />
    </React.Fragment>
  );
};

export default SingleDose;
